import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';
import { useTranslation } from 'react-i18next';
import { playSound } from '../utils/soundPlayer';
import './LeaderboardArchivePage.css';

const LeaderboardArchivePage = () => {
  const { archiveId } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [archive, setArchive] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadArchive = async () => {
      try {
        const archiveDoc = await getDoc(doc(db, 'leaderboardArchives', archiveId));
        
        if (archiveDoc.exists()) {
          setArchive({
            id: archiveDoc.id,
            ...archiveDoc.data()
          });
        } else {
          console.error('Archive not found');
        }
      } catch (error) {
        console.error('Error loading archive:', error);
      } finally {
        setLoading(false);
      }
    };

    loadArchive();
  }, [archiveId]);

  if (loading) {
    return (
      <div className="leaderboard-archive-page">
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>{t('leaderboardArchives.loadingArchive')}</p>
        </div>
      </div>
    );
  }

  if (!archive) {
    return (
      <div className="leaderboard-archive-page">
        <div className="error-container">
          <h2>{t('leaderboardArchives.archiveNotFound')}</h2>
          <button 
            className="back-button"
            onClick={() => {
              playSound('return');
              navigate('/leaderboard-archives');
            }}
          >
            {t('leaderboardArchives.backToArchives')}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="leaderboard-archive-page">
      <div className="archive-header-info">
        <h1> {archive.name}</h1>
        <div className="archive-meta">
          <span className="archive-total">
            {archive.totalDuelists} {t('leaderboardArchives.duelists')}
          </span>
        </div>
      </div>

      <div className="duelist-list">
        {archive.leaderboard?.map((duelist) => {
          const isUnranked = String(duelist.division).toLowerCase() === 'unranked';
          
          let divisionClass = '';
          const divisionValue = duelist.division.toLowerCase();
          if (divisionValue === 'unranked') {
            divisionClass = 'red';
          } else if (divisionValue.includes('obelisk')) {
            divisionClass = 'blue';
          } else if (divisionValue.includes('ra')) {
            divisionClass = 'yellow';
          } else if (divisionValue.includes('slifer')) {
            divisionClass = 'red';
          }

          return (
            <div
              key={duelist.userId}
              className={`duelist-card ${
                divisionClass === 'blue'
                  ? 'obelisk-glow'
                  : divisionClass === 'yellow'
                  ? 'ra-glow'
                  : divisionClass === 'red'
                  ? 'slifer-border'
                  : ''
              }`}
              onClick={() => navigate(`/profile/${duelist.userId}`)}
              style={{ cursor: 'pointer' }}
            >
              <div className="duelist-left">
                <span className={`duelist-rank ${divisionClass}`}>#{duelist.rank}</span>
                <img
                  onMouseDown={(e) => e.button === 2 && e.preventDefault()}
                  onTouchStart={(e) => e.preventDefault()}
                  draggable={false}
                  className="duelist-avatar"
                  src={duelist.profilePicture || '/default-avatar.png'}
                  alt="avatar"
                />
                <div className="duelist-info">
                  <p className="duelist-name">{duelist.pseudo}</p>
                  <p className={`duelist-division ${divisionClass}`}>
                    {duelist.division}
                  </p>
                </div>
              </div>
              <div className="duelist-yp">
                {duelist.YP !== undefined ? `YP: ${duelist.YP}` : ''}
              </div>
            </div>
          );
        })}
      </div>

      <button
        className="back-button"
        onClick={() => {
          playSound('return');
          navigate('/leaderboard-archives');
        }}
      >
        {t('leaderboardArchives.backToArchives')}
      </button>
    </div>
  );
};

export default LeaderboardArchivePage;
